import styled from 'styled-components';
import { Col } from 'react-bootstrap';
import loadBackground from 'assets/images/calendar/load-bg.jpeg';
import { StackedCalendarMode } from '../Calendar.types';
import { stackedCalendarStyleConstants } from '../Calendar.constants';
import { LoadingDayCellStyles } from './days/LoadingDayCell.styles';
import { DayCellStyles } from './days/DayCell.styles';
import { LeadViewStyles } from './leads/LeadView.styles';

export const StackedCalendarBodyStyled = styled(Col).attrs<{
  $mode: StackedCalendarMode;
}>(({ $mode }) => ({
  className: `stacked-calendar-body-mode-${$mode.toLowerCase()}`,
}))`
  background: url(${loadBackground}) repeat;
  overflow: hidden;
  width: 100%;

  ${({ $mode }) =>
    $mode === StackedCalendarMode.PRICING &&
    `
      .day-cell-job,
      .day-cell-lead-container {
        opacity: 0.5;
      }
  `}

  .stacked-calendar-body-container {
    background-color: #fff;
    display: flex;
  }

  .stacked-calendar-body-container-scrollable {
    display: flex;
    flex-direction: column;
    overflow: auto;
    position: relative;
    transform: translate3d(0, 0, 0);
    width: 100%;
  }

  .stacked-calendar-body-row {
    display: flex;
    flex: 1 1 auto;
    position: relative;
  }

  /* Spacers double as loading panels: an empty cell grid (gradients mirror the cell borders) plus the weekend tint (--first-sat-index) and past-day shade (--past-days-count), so a fast scroll shows a grid seamless with real cells instead of blank. */
  ${({ $mode }) => {
    const cellWidth = stackedCalendarStyleConstants.daysCellWidth[$mode];
    const rowHeight = stackedCalendarStyleConstants.days.height;
    const pastEnd = `calc(var(--past-days-count, 0) * ${cellWidth}px)`;
    return `
    .virtualization-loading-panel {
      background-color: #fff;
      background-image: repeating-linear-gradient(
          to right,
          rgb(221, 221, 221) 0 1px,
          transparent 1px ${cellWidth}px
        ),
        repeating-linear-gradient(
          to bottom,
          rgb(221, 221, 221) 0 1px,
          transparent 1px ${rowHeight}px
        ),
        linear-gradient(
          to right,
          rgb(243, 243, 247) ${pastEnd},
          transparent ${pastEnd}
        ),
        repeating-linear-gradient(
          to right,
          rgba(102, 153, 204, 0.2) 0 ${2 * cellWidth}px,
          transparent ${2 * cellWidth}px ${7 * cellWidth}px
        );
      background-position: 0 0, 0 0, 0 0,
        calc(var(--first-sat-index, 0) * ${cellWidth}px) 0;
    }
  `;
  }}

  ${LoadingDayCellStyles}

  ${DayCellStyles}
  
  ${LeadViewStyles}
`;

// @ts-expect-error TS7006 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
export const getSelectionStyle = ($propertyUid, isPricingMode) =>
  !!$propertyUid &&
  !isPricingMode &&
  `
  div.body-day-cell:not([data-property-uid='${$propertyUid}']):before {
    content: '';
    background-color: rgb(221 221 221 / 50%);
    height: 40px;
    width: 100%;
    position: absolute;
    left: 0;
  }
`;
